/** Returns nested `Booking` object when present and record-shaped. */
export function readNestedBookingRecord(
  source: Record<string, unknown>
): Record<string, unknown> | undefined {
  const nested = source['Booking'];
  if (nested && typeof nested === 'object' && !Array.isArray(nested)) {
    return nested as Record<string, unknown>;
  }
  return undefined;
}
